import { Platform } from "@angular/cdk/platform";
import { afterNextRender, Component, inject } from "@angular/core";
import { RouterModule } from "@angular/router";
import { StatusBar } from "@capacitor/status-bar";
import { CapacitorKakaoLogin } from "@team-lepisode/capacitor-kakao-login";
import { initializeApp } from "firebase/app";
import { register } from "swiper/element/bundle";
import { environment } from "../env/env";

register();

@Component({
    standalone: true,
    imports: [RouterModule],
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
})
export class AppComponent {
    private readonly platform = inject(Platform);

    constructor() {
        initializeApp(environment.firebase);

        afterNextRender(() => {
            if (this.platform.ANDROID || this.platform.IOS) {
                StatusBar.setOverlaysWebView({ overlay: true });
                CapacitorKakaoLogin.initialize({
                    appKey: environment.kakao.appKey,
                });
            }
        });
    }
}
